(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promotionspecial-products"] && !Shopify.designMode) return;
  try {
    
Date.prototype.dst = function() {
    var year = this.getFullYear();
    var jan = new Date(year, 0, 1);
    var jul = new Date(year, 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) !== this.getTimezoneOffset();
};

function saveScrollPosition() {
    sessionStorage.setItem('scrollPosition', window.scrollY || document.documentElement.scrollTop);
}
  
function redirectToThankYouPage() {
    window.location.href = 'https://www.onceagain.fr/pages/remerciements';
}

function showPreRedirectionMessage() {
      document.getElementById("pre-redirection-message").style.display = "block";
  }

function formatPrice(price) {
    let formattedPrice = parseFloat(price).toFixed(2);
    formattedPrice = formattedPrice.replace('.', ',');
    return formattedPrice + '€';
}
  
function updatePrices() {
    saveScrollPosition();
    window.location.reload();
  
  // console.log('MAJ des prix')
  //   fetch('/collections/promotionspecial/products.json?limit=100')
  //        .then(response => response.json())
  //        .then(data => {
  //           console.log("MAJ prodcuts", data);
  //           data.products.forEach(product => {
  //               // Mettez à jour le prix du produit sur la page
  //               // var priceElement = document.querySelector('.sale-price[data-product-id="' + product.id + '"]');
  //               // if (priceElement) {
  //               //     priceElement.innerHTML = product.variants[0].price; // Assurez-vous que cela correspond à la structure de vos données
  //               //   console.log(`Prix mis à jour pour le produit ${product.id}`);
  //               // }
  //       var priceElements = document.querySelectorAll('.sale-price[data-product-id="' + product.id + '"]');
  //       priceElements.forEach(el => {
  //           el.innerHTML = formatPrice(product.variants[0].price); // Utilisez votre fonction de formatage de prix
  //       });

              
  //           });
  //       })
  //       .catch(error => console.error('Error:', error));
}
  
const HOUR_OF_OPERATION = 19; // 10 AM heure locale de Paris
var now = new Date();
var parisOffset = -60; // Paris est normalement à UTC+1
var isSummerTime = now.dst(); // Fonction pour déterminer si c'est l'heure d'été
var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
var parisOffset = 1; // Paris est normalement à UTC+1
var parisTime = new Date(utc + (3600000*1));
var startOfOperationToday = new Date(parisTime.getFullYear(), parisTime.getMonth(), parisTime.getDate(), HOUR_OF_OPERATION, 0, 0);
var endOfOperationToday = new Date(startOfOperationToday.getTime() + (3600000)); // Une heure de durée  
let shouldRefresh = false;
  
document.addEventListener('DOMContentLoaded', function() {
    if (isSummerTime) {
        parisOffset -= 120; // Enlève une heure supplémentaire si c'est l'heure d'été
    }
    
    // Fonction pour déterminer l'heure d'été
    Date.prototype.dst = function() {
        var year = this.getFullYear();
        var jan = new Date(year, 0, 1);
        var jul = new Date(year, 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) !== this.getTimezoneOffset();
    };

    //var parisTime = new Date(now.getTime() + (now.getTimezoneOffset() + parisOffset) * 60000);
    
    var klaviyoBlocks = document.querySelectorAll('.klavyio-block');
    var timerElement = document.getElementById("timer");

    // Si l'heure actuelle est après l'heure de fin de l'opération ou avant l'heure de début, calculez le temps pour l'opération de demain
    if (parisTime >= endOfOperationToday || parisTime < startOfOperationToday) {
       /* if (parisTime.getHours() >= HOUR_OF_OPERATION) {
            // Si l'heure actuelle est passé 10h, l'opération est pour demain
          
        }*/

        startOfOperationToday.setDate(startOfOperationToday.getDate() + 1);
        countDown(startOfOperationToday, "Prochaine opération dans : ");
        shouldRefresh = false;
    } else {
        // Sinon, l'opération est pour aujourd'hui
        countDown(endOfOperationToday, "Fin de l'opération dans : ");
        // Mettre à jour les prix toutes les 5 minutes
        shouldRefresh = true;
        setInterval(updatePrices, 150000); // 300000 ms = 5 minutes
        setTimeout(showPreRedirectionMessage, (58 * 60 * 1000)); // 58 minutes après le début de l'événement
         klaviyoBlocks.forEach(function(block) {
              block.style.display = 'none';
          });
    }


    
    function countDown(targetDate, message) {
        var x = setInterval(function() {
            var now = new Date();
            var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
            var parisOffset = 1; // Paris est normalement à UTC+1
          var parisTime = new Date(utc + (3600000*1));

            var distance = targetDate - parisTime;

            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            timerElement.innerHTML = message + hours + "h " + minutes + "m " + seconds + "s ";

            if (distance < 0) {
                clearInterval(x);
                document.getElementById("timer").innerHTML = "L'opération est terminée";
                redirectToThankYouPage(); // ou reloadPage()
            }
        }, 1000);
    }

console.log('valeur de should refresh',shouldRefresh)


  
});


function loadAdditionalProducts() {
    fetch('/collections/promotionspecial/products.json?limit=100')
        .then(response => response.json())
        .then(data => {
            // La réponse contient les données des produits
          console.log("on recharge les pdts")
            const products = data.products;
            const productsContainer = document.querySelector('.product-grid');

            // Itérer sur les produits et les ajouter au conteneur
            for (let i = 50; i < products.length; i++) {
                let product = products[i];
                let productDiv = document.createElement('div');
                productDiv.className = 'product-grid-item';
                let productPrice = formatPrice(product.variants[0].price);
                let compareAtPriceHtml = product.variants[0].compare_at_price ? `<span class="original-price">${formatPrice(product.variants[0].compare_at_price)}</span>` : '';
                let brand = product.title.length > 20 ? product.title.substring(0, 17) + '...' : product.title;  
                let productType = product.product_type.length > 20 ? product.product_type.substring(0, 17) + '...' : product.product_type; 
                let discountHtml = '';
                  if (product.variants[0].compare_at_price > product.variants[0].price) {
                      let difference = product.variants[0].compare_at_price - product.variants[0].price;
                      let discountPercentage = Math.round((difference / product.variants[0].compare_at_price) * 100);
  
                      discountHtml = `<div class="discount-badge">- ${discountPercentage}%</div>`;
                  }
              let klaviyoHtml= '';
                if (parisTime >= endOfOperationToday || parisTime < startOfOperationToday) {
                     klaviyoHtml = `<div class="klavyio-block">
                                    <div class="klaviyo-form-WHUDLC"></div>
                                    </div>`
                }              
              productDiv.innerHTML = `
                      <a href="/products/${product.handle}" class="product-grid-item-link">
                                <img src="${product.images[0].src}" alt="${product.title}" class="product-grid-item-link">
                                ${discountHtml}
                      </a>
                    <div class="product-grid-brand">${brand}
                      <button class="cstm_ad_to_cart_ps" id="ad_to_cart_ps" data-add-to-cart=${product.variants[0].id} data-action="add-to-cart"></button>
                    </div>
                    <div class="product-grid-type">${productType}</div>
                    <div class="product-grid-type">Taille: ${product.options[0].values}</div>
                    <div class="product-grid-price">
                       ${compareAtPriceHtml}
                      <span class="sale-price" data-product-id="${product.variants[0].id}">${productPrice}</span>
                    </div>    
                `;
                productsContainer.appendChild(productDiv);
            }
        });
}


// Appeler cette fonction au chargement de la page
document.addEventListener('DOMContentLoaded', loadAdditionalProducts);

  
  

  } catch(e) { console.error(e); }
})();
})();
